import { FC } from "react";

type Props = {
  msDelay: number;
};

const BouncingDot: FC<Props> = ({ msDelay }) => {
  return (
    <div
      className="size-2 rounded-full bg-assistant-message-dots animate-bounce"
      style={{ animationDelay: `${msDelay}ms` }}
    ></div>
  );
};

export default BouncingDot;
